import Component from '../app/component'
import Flickity from 'flickity'

export default class PostsSliderComponent extends Component {
  constructor(el) {
    super(el)
    this.data = {
      page: 1
    }
  }

  init() {
    this.sliderSetup()
  }

  sliderSetup() {
    if (!this.refs.sliderWrapper) {
      return
    }

    this.slider = new Flickity(
      this.refs.sliderWrapper,
      {
        freeScroll: true,
        contain: true,
        prevNextButtons: false,
        pageDots: false,
        cellAlign: 'left',
        wrapAround: false
      }
    )

    if (this.refs.arrowLeft) {
      console.log('left')
      this.refs.arrowLeft.addEventListener('click', () => {
        this.slider.next()
      })
    }

    if (this.refs.arrowRight) {
      this.refs.arrowRight.addEventListener('click', () => {
        this.slider.previous()
      })
    }
  }
}
